import TagsActions from '../actions/TagsCRUDActions';
import Actions from '../actions/actions';
import { setUnBusy, setBusy, retrievedAll } from './common/commonReducers';
import TagModel from '../model/TagModel';
import { TagsState } from '../interfaces/tags';
import { handleActions } from 'redux-actions';

type ActionType = {
  type: string;
  entities?: TagModel[];
  entity?: TagModel;
};

const onSetTag = (state: TagsState, action: ActionType) => {
  if (
    action.entity === undefined ||
    state.entities.find(
      e =>
        e.name === (action.entity || {}).name &&
        e.kind === (action.entity || {}).kind,
    )
  ) {
    return {
      ...state,
      busy: false,
    };
  }

  return {
    busy: false,
    entities: [...state.entities, action.entity],
  };
};

const onDeleteTag = (state: TagsState, action: ActionType) => ({
  busy: false,
  entities: state.entities.filter(
    e =>
      !(
        e.name === (action.entity || {}).name &&
        e.kind === (action.entity || {}).kind
      ),
  ),
});

const initialState: TagsState = {
  busy: false,
  entities: [],
};

const mappedReducers = {
  [TagsActions.busyAction]: (state: TagsState) => setBusy(state),
  [TagsActions.getTagsAction]: retrievedAll,
  [TagsActions.deleteTagAction]: onDeleteTag,
  [TagsActions.setTagAction]: onSetTag,
  [TagsActions.assignTagAction]: setUnBusy,
  [TagsActions.unassignTagAction]: setUnBusy,
  [Actions.RESET]: () => initialState,
  [Actions.UNBUSY]: setUnBusy,
};

const tags = handleActions(mappedReducers, initialState);

export default tags;
